var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobeRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.265,
    height: 20.265,
    viewBox: "0 0 20.265 20.265",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.632-.5A10.132,10.132,0,1,1-.5,9.632,10.144,10.144,0,0,1,9.632-.5Zm0,19.265A9.132,9.132,0,1,0,.5,9.632,9.143,9.143,0,0,0,9.632,18.765Z",
    transform: "translate(0 0.034)",
    fill: "#f95047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.489,55.878H24.753v1H5.489Z",
    transform: "translate(-5.489 -46.312)",
    fill: "#f95047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.465,37.092H5.489v-1H23.465Z",
    transform: "translate(-4.933 -30.21)",
    fill: "#f95047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42,75.665H24.861v1H7.42Z",
    transform: "translate(-6.504 -62.415)",
    fill: "#f95047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.082,22.078a15.9,15.9,0,0,1-.388-19.363L35.07,2.2l.805.593-.376.511a14.9,14.9,0,0,0,.364,18.145l.11.137v.175h-.5Z",
    transform: "translate(-26.587 -2.466)",
    fill: "#f95047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.766,21.892l-.39-.312h-.5V21.4l.11-.137a14.9,14.9,0,0,0,.364-18.145l-.376-.51.805-.593.376.511a15.9,15.9,0,0,1-.388,19.363Z",
    transform: "translate(-47.972 -2.315)",
    fill: "#f95047"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeRed);
export default __webpack_public_path__ + "static/media/globe-red.a34c330ee940553abdcf28b384963c17.svg";
export { ForwardRef as ReactComponent };